import React from 'react';
import { Portal } from '@edreamsodigeo/frontend-core';
import { FlightSelectorLCPage as ModifyFlightSelectorLCPage } from '@edreamsodigeo/frontend-booking-admin';
const FlightSelectorLCPage = () => {
  return /*#__PURE__*/React.createElement(Portal, {
    elementId: "modification-flight-selector-lc-container",
    Component: ModifyFlightSelectorLCPage
  });
};
export default FlightSelectorLCPage;